"use client";

import PopularListItemCard from "@/components/PopularListItemCard";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import PopularRentalCars from "@/components/pages/car/sections/popular-rental-cars/PopularRentalCars";
import LocationAnalytics from "@/components/pages/car/sections/LocationAnalytics";
import PopularCompaniesCard from "@/components/pages/car/cards/PopularCompanyCard";

import {
  CampaignCard,
  BenefitCard,
  BrandCard,
  RegisterBanner,
  PopularLocationCard,
  AppBanner,
} from "@/components/featured/common";

import BlogCard from "@/components/featured/common/cards/BlogCard";

export const carCityComponentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  PopularListItemCard,
  BenefitCard,
  BrandCard,
  BlogCard,
  AppBanner,
  PopularLocationCard, 
  RegisterBanner,
  PopularRentalCars,
  PopularCompaniesCard,
  LocationAnalytics
};

export const carCityItemPropMapping = {
  OpportunitiesCardWrapper : "item",
  CampaignCard: "item",
  PopularListItemCard: "item",
  BenefitCard: "item",
  ThemeCard: "item",
  BrandCard: "brand",
  BlogCard: "post",
  PopularLocationCard: "item",
  PopularRentalCarCard: "item",
  PopularRentalCars: "cars",
  PopularCompaniesCard: "item",
  LocationAnalytics: "location"
};
